import {RoomImage} from "../../../api/apiClient";
import {Box, List} from "@mui/material";
import {RoomRow} from "./RoomRow";
import {useMemo} from "react";
import {PANEL_GUTTER} from "./useNavLayout";

export interface BrowserRoomMenuProps {
    rooms: RoomImage[];
    currentPanorama: string;
    changePanorama: (panorama: string) => void;
}

export function BrowserRoomMenu(props: BrowserRoomMenuProps) {
    const {rooms, currentPanorama, changePanorama} = props;

    // The floor name only helps when the rooms are spread over more than one floor.
    const hasSeveralFloors = useMemo(
        () => new Set(rooms.map(room => room.floor).filter(Boolean)).size > 1,
        [rooms]);

    return <Box sx={{flexGrow: 1, minHeight: 0, overflowY: "auto", px: PANEL_GUTTER}}>
        <List disablePadding>
            {rooms.map(room => <RoomRow key={"room-row-" + room.targetPanorama}
                                        room={room}
                                        isCurrent={room.targetPanorama === currentPanorama}
                                        showFloor={hasSeveralFloors}
                                        onClick={changePanorama}/>)}
        </List>
    </Box>
}
